import React from 'react';
import { Link } from 'react-router-dom';
import { generatePath } from "react-router"

export default class MyForms extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            error: false,
            forms: [],
            displayForms:[],
            formFilters: [],
            formFilter: 0,
            canArchive: false
        }
    }
    componentDidMount()
    {
        this.loadMyForms();
    }
    loadMyForms()
    {
        this.props.api.send({
            controller: "Form",
            action: "GetMyForms",
            method: "get",
            success: (response) => {
                var uniqueForms = [{formID: 0, formName: "-- Select a Form --"}];
                response.forms.filter(function(item){
                  var i = uniqueForms.findIndex(x => x.formName === item.formName);
                  if(i <= -1){
                    uniqueForms.push({formID: item.formID, formName: item.formName});
                  }
                  return null;
                });
                
                var filteredForms = this.filterDisplayedForms(this.state.formFilter, response.forms);   
                response.success ?
                    this.setState({loaded: true, canArchive: response.canArchive, forms: response.forms, formFilters: uniqueForms, displayForms: filteredForms}) :
                    this.setState({loaded: true, error: true})
            },
            error: (err) => {
                this.setState({loaded: true, error: true})
            }
        })
    }
    
    filterChanged(e)
    {
        var forms = this.state.forms;
        var filteredForms = this.filterDisplayedForms(e.target.value, forms);
        this.setState({displayForms: filteredForms, formFilter: e.target.value})
    }

    filterDisplayedForms(id, forms){
        let filteredForms = this.state.displayForms;
        id = Number(id);
        if(id === 0){
            filteredForms = forms;
        }else{
            filteredForms = forms.filter((f) => f.formID === id);
        }
        return filteredForms;
    }

    getFormResults(e){
        var chunks = e.target.id.split("_");
        var id = (chunks.length === 2 ? chunks[1] : -1);
        var url = generatePath("/Forms/view/:id/", { id: id})
        window.open(url,'popUpWindow','height=500,width=900,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');
    }
    setFormArchive(e){
        var chunks = e.target.id.split("_");
        var id = (chunks.length === 2 ? chunks[1] : -1);
        // ArchiveForm
        this.setState({loaded: false}, () => {
            this.props.api.send({
                controller: "Form",
                action: "ArchiveForm",
                method: "post",
                body: JSON.stringify({completedFormID: id}),
                success: (result) => {
                    console.log(result);
                    if(result.success === true){
                        this.loadMyForms();
                        this.setState({
                            loaded: true
                        });
                    }
                },
                error: (err) => {
                    this.setState({loaded: true});
                }
            })
        });
    }

    render()
    {
        const formlist = this.state.displayForms.map((f) => 
            <tr key={f.completedFormID}>
                <td>{f.formName}</td>
                <td>{f.formDescription}</td>
                <td>{f.username}</td>
                <td>{f.dateCompleted}</td>
                <td style={{width: "275px"}}>
                    <Link to="#" id={"results_" + f.completedFormID} onClick={this.getFormResults.bind(this)} className="lmsbutton">Results</Link>
                    {this.state.canArchive ? (<Link to="#" id={"archive_" + f.completedFormID} onClick={this.setFormArchive.bind(this)} className="lmsbutton">Archive</Link>)
                    : ("")}
                </td>
            </tr>
        ,this)
        const filters = this.state.formFilters.map(f => 
            <option key={f.formID} value={f.formID}>{f.formName}</option>  
        ,this)
        return (
            <div>
                <select className="lmsforminput" style={{marginBottom: "12px"}} 
                    onChange={(e) => this.filterChanged(e)}
                    value={this.state.formFilter}
                    >
                    {filters}
                </select>
                {this.state.loaded ?
                    this.state.displayForms.length > 0 ? (
                        <div style={{marginTop: "10px"}}>
                            <table className="lmstable" style={{marginTop: "12px"}}>
                                <tbody>
                                    <tr>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>User</th>
                                        <th>Date</th>
                                        <th>Actions</th>
                                    </tr>
                                    {formlist}
                                </tbody>
                            </table>                            
                        </div>
                    ) : (
                    <p>
                        <i>You do not have any forms completed. Check the Form listing for available forms. </i>
                    </p>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/forms/myforms.js